import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, useEffect, useMemo, Children, cloneElement, createElement, Fragment } from 'react';
import cn from 'classnames';
import { getAppearanceClasses } from '../../utils/taillwind.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { useProxiedRef } from '../../utils/hooks/useProxiedRef.js';
import { useBoundingClientRectListener } from '../../utils/hooks/useBoundingClientRectListener.js';
import { useMenuState, MenuButton, Menu as Menu$1, MenuItem, MenuSeparator, MenuItemCheckbox, MenuItemRadio } from 'reakit/Menu';

var _excluded = ["appearance", "children", "disclosure", "disclosureTooltip", "onChange", "value"],
    _excluded2 = ["modal"],
    _excluded3 = ["hide", "onClick"],
    _excluded4 = ["hide", "modal", "onClick"];
var Menu = /*#__PURE__*/forwardRef(function Menu(props, ref) {
  var _cn;

  var appearance = props.appearance,
      children = props.children,
      disclosure = props.disclosure,
      disclosureTooltip = props.disclosureTooltip,
      onChange = props.onChange,
      value = props.value,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var internalRef = useProxiedRef(ref);
  var buttonDimensions = useBoundingClientRectListener(internalRef);
  var menu = useMenuState({
    unstable_values: value
  });
  useEffect(function () {
    if (onChange) {
      onChange(menu.unstable_values);
    }
  }, [menu.unstable_values]);

  var menuProps = _objectWithoutPropertiesLoose(menu, _excluded2);

  var className = cn('yt-menu', (_cn = {}, _cn[getAppearanceClasses(appearance)] = !!appearance, _cn), props.className);
  var childrenWithProps = useMemo(function () {
    return Children.toArray(children).filter(function (x) {
      return !!x;
    }).map(function (child) {
      return cloneElement(child, _extends({}, menuProps, {
        hide: function hide() {
          menu.hide();

          if (child.props.hide) {
            child.props.hide();
          }
        }
      }));
    });
  }, [children, menu.unstable_values]);
  return createElement(Fragment, null, disclosure && // We reset pointerEvents cause reakit automatically adds it to its disabled buttons
  // whereas we want to have a disabled cursor showing.
  createElement(MenuButton, Object.assign({}, menu, disclosure.props, {
    ref: internalRef,
    style: {
      pointerEvents: 'initial'
    }
  }), function (disclosureProps) {
    var button = cloneElement(disclosure, disclosureProps);
    return disclosureTooltip ? createElement(Tooltip, {
      title: disclosureTooltip
    }, button) : button;
  }), createElement(Menu$1, Object.assign({}, otherProps, menu, {
    className: className,
    style: {
      minWidth: buttonDimensions === null || buttonDimensions === void 0 ? void 0 : buttonDimensions.width
    }
  }), childrenWithProps));
});

Menu.Link = function (props) {
  var hide = props.hide,
      onClick = props.onClick,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded3);

  var handleClick = function handleClick(event) {
    event.persist();
    hide();

    if (onClick) {
      onClick(event);
    }
  };

  return createElement(MenuItem, Object.assign({}, otherProps, {
    onClick: handleClick,
    as: "a"
  }));
};

Menu.Item = function (props) {
  var hide = props.hide,
      modal = props.modal,
      onClick = props.onClick,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded4);

  if (modal) {
    return modal({
      disclosure: createElement(MenuItem, {
        id: otherProps.baseId,
        disabled: otherProps.disabled,
        children: otherProps.children
      }),
      onHide: hide
    });
  }

  var handleClick = function handleClick(event) {
    event.persist();
    hide();

    if (onClick) {
      onClick(event);
    }
  };

  return createElement(MenuItem, Object.assign({}, otherProps, {
    onClick: handleClick
  }));
};

Menu.Separator = MenuSeparator;
Menu.ItemCheckbox = MenuItemCheckbox;
Menu.ItemRadio = MenuItemRadio;

export { Menu };
//# sourceMappingURL=Menu.js.map
